import { Header } from 'src/components';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 48px 0;
`;

const Message = styled.p`
  margin: 24px 0 0;
  font-size: 16px;
  color: ${p => p.theme.palette.text.low};
`;

type PlaceholderViewProps = {
  title: string;
  message?: string;
};

export const PlaceholderView: React.FC<PlaceholderViewProps> = ({
  title,
  message = 'Treść wkrótce.',
}) => (
  <Wrapper>
    <Header title={title} as="h1" />
    <Message>{message}</Message>
  </Wrapper>
);
